var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-info" },
    [
      _c(
        "div",
        [
          _vm.orderEditType !== 2
            ? _c(
                "el-form",
                {
                  ref: "goodsInfoFilter",
                  attrs: { model: _vm.form, "label-width": "90px" },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "包装号", prop: "packageNo" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.packageNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "packageNo", $$v)
                                  },
                                  expression: "form.packageNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SKU号", prop: "itemNo" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.itemNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "itemNo", $$v)
                                  },
                                  expression: "form.itemNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "生产商", prop: "producerName" }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.producerName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "producerName", $$v)
                                  },
                                  expression: "form.producerName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function() {
                                      return _vm.handleQuery(1)
                                    }
                                  }
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                { on: { click: _vm.handleReset } },
                                [_vm._v("重置")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("div", [
        _vm.orderEditType === 1 && _vm.poState === 0
          ? _c(
              "div",
              { staticClass: "trigger", staticStyle: { flex: "1" } },
              [
                _c(
                  "el-form",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleAdd }
                      },
                      [_vm._v("新增")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleEdit }
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleDel }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.sumInfo && _vm.orderEditType !== 2
          ? _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c(
                  "div",
                  {
                    class: ["total", _vm.form.eqFlag ? "notEq" : ""],
                    on: { click: _vm.totalClick }
                  },
                  [
                    _vm._v(
                      "总包装数:" +
                        _vm._s(_vm.sumInfo.sumEstimatedQuantity) +
                        "/"
                    ),
                    _c(
                      "span",
                      {
                        style: {
                          color:
                            _vm.sumInfo.sumEstimatedQuantity ===
                            _vm.sumInfo.sumQuantity
                              ? ""
                              : "red"
                        }
                      },
                      [_vm._v(_vm._s(_vm.sumInfo.sumQuantity))]
                    )
                  ]
                ),
                _c("div", { staticStyle: { margin: "0 10px" } }, [
                  _vm._v(
                    "总体积(CBM):" +
                      _vm._s(_vm.sumInfo.sumEstimatedCubage) +
                      "/" +
                      _vm._s(_vm.sumInfo.sumCubage)
                  )
                ]),
                _c("div", [
                  _vm._v(
                    "总重量(KGS):" +
                      _vm._s(_vm.sumInfo.sumEstimatedGrossWeight) +
                      "/" +
                      _vm._s(_vm.sumInfo.sumGrossWeight)
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _c(
        "div",
        { staticStyle: { display: "flex", "margin-top": "5px" } },
        [
          _c("cargo-ag-grid", {
            ref: "goodsTable",
            staticStyle: { height: "400px" },
            attrs: {
              "config-module": "700003",
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-form",
            [
              _c("cargo-pagination", {
                attrs: {
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  "page-sizes": [10, 20, 30, 50, 100, 200, 500]
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function() {
                    return _vm.handleQuery()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("package-info-form", {
        ref: "packageInfoForm",
        attrs: {
          visible: _vm.visible,
          uuid: _vm.editRow ? _vm.editRow.uuid : null,
          "po-no": _vm.poNo,
          "order-uuid": _vm.orderUuid,
          "customer-id": _vm.customerId
        },
        on: { onSave: _vm.goodsSave, onClose: _vm.handleClose }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }